const classOptions = [
  { value: 943240033, displayValue: "Food and Nutrition" },
  { value: 943240009, displayValue: "English" },
  { value: 943240008, displayValue: "Dramatic Arts" },
  { value: 943240030, displayValue: "Textile Arts and Design" },
  { value: 943240031, displayValue: "Visual Arts" },
  { value: 943240023, displayValue: "Biology" },
  { value: 943240003, displayValue: "Chemistry" },
  { value: 943240004, displayValue: "Cinema - witness to modern history" },
  { value: 943240007, displayValue: "Dance" },
  { value: 943240002, displayValue: "Canadian law" },
  { value: 943240025, displayValue: "Physical education" },
  { value: 943240014, displayValue: "Global issues" },
  { value: 943240021, displayValue: "Leadership Training" },
  { value: 943240029, displayValue: "Spanish" },
  { value: 943240011, displayValue: "Family Studies" },
  { value: 943240035, displayValue: "French (As a 1st language)" },
  { value: 943240012, displayValue: "French (As a 2nd language)" },
  { value: 943240013, displayValue: "Geography" },
  { value: 943240015, displayValue: "Guitar" },
  { value: 943240016, displayValue: "Harmony" },
  { value: 943240017, displayValue: "History" },
  { value: 943240005, displayValue: "Computer science" },
  { value: 943240018, displayValue: "Introduction to Calculus" },
  {
    value: 943240019,
    displayValue: "Introduction to Calculus and Advanced Mathematics",
  },
  { value: 943240020, displayValue: "Jazz" },
  { value: 943240001, displayValue: "Applied mathematics" },
  { value: 943240010, displayValue: "Everyday mathematics" },
  { value: 943240000, displayValue: "Advanced Mathematics" },
  { value: 943240027, displayValue: "Pre-Calculus Mathematics" },
  { value: 943240022, displayValue: "Music" },
  { value: 943240024, displayValue: "Philosophy" },
  { value: 943240026, displayValue: "Physics" },
  { value: 943240028, displayValue: "Psychology" },
  { value: 943240006, displayValue: "Current topics" },
  { value: 943240032, displayValue: "Work-life: Transition" },
  { value: 943240034, displayValue: "Other" },
];

export default classOptions;
